import http from '../utils/http';

export function studentList(params) {
  return http.get(`${window.location.origin}/mock/student/list`, {
    params: {
      ...params,
    },
  });
}
